import { Component, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { Observable } from 'rxjs';

import { ContratoService } from '../../../../providers/contrato-service';
import { ContratosGestaoService } from '../../../../providers/contratos-gestao-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';

import { IMyDpOptions, IMyDateModel } from 'mydatepicker';

import { ModalArquivosPage } from "../../../modais/modal-arquivos/modal-arquivos";

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

declare var jsPDF: any;

@Component({
    selector: 'page-pessoal-vinculado',
    templateUrl: 'pessoal-vinculado.html',
    providers: [
        ContratosGestaoService
    ]
})
export class PessoalVinculadoPage extends ModulosController {
    listaDados: any = [];
    listaContratos: any = [];
    listaContratosAux: any = [];
    loading: boolean = true;
    idSecaoPagina: string = "148";
    tiposArquivosAceitos: string = "application/xls";
    dadosImportados: any[];

    searchLoading: boolean = true;

    cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    cpfPreenchido: boolean = false;
    cpfCarregado: boolean = true;
    cpfInvalido: boolean = false;

    numberMask = createNumberMask({
        prefix: '',
        suffix: '', // This will put the dollar sign at the end, with a space.
        thousandsSeparatorSymbol: '.',
        allowDecimal: true,
        decimalSymbol: ','
    });

    relatorioParaAdicionar: any = {
        nmContrato: '',
        nomePessoa: '',
        funcaoDesenvolvida: '',
        dataAdmissao: '',
        cpf: '',
        dataDesligamento: '',
        valorJaneiro: '',
        valorFevereiro: '',
        valorMarco: '',
        valorAbril: '',
        valorMaio: '',
        valorJunho: '',
        valorJulho: '',
        valorAgosto: '',
        valorSetembro: '',
        valorOutubro: '',
        valorNovembro: '',
        valorDezembro: ''

        
    }

    page1: number = 1;

    pagination = {
        TotalItems: 100,
        CurrentPage: 1,
        PageSize: 10,
        TotalPageLinkButtons: 5,
        RowsPerPageOptions: [10]
    };

    selectedItem: any = '';
    inputChanged: any = '';

    myDatePickerAdmissaoOptions: IMyDpOptions;
    myDatePickerDesligamentoOptions: IMyDpOptions;
    codigoModulo: any = 0;
    typeahead = new EventEmitter<string>();

    objetoEdit: any = null;
    listEdit: any = [];

    comboContratos: any = null;
    analise: any = null;

    @ViewChild('inputFileCM')
    inputFileCMVar: ElementRef;

    desabilitarImportacao = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public contratosGestaoService: ContratosGestaoService,
        public contratoService: ContratoService,
        private fileService: FileService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.analise = this.navParams.get('analise');

        if (this.isJurisdicionado) {
            this.codigoModulo = this.navParams.get('analise').idModuloPca;
        }

        this.myDatePickerAdmissaoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
        };

        this.myDatePickerDesligamentoOptions = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false,
            componentDisabled: true
        };

        this.carregarDados();
        this.setModuloId(14);

        // this.typeahead
           // .pipe(distinctUntilChanged(), debounceTime(200), switchMap(term => this.buscarContratos(term)))
           // .subscribe(items => {
             //   this.listaContratos = items;
           // }, (err) => {
             //   console.log(err);
              //  this.listaContratos = [];
            //});
    }

    carregarDados() {

        this.desabilitarImportacao = true;

        this.searchLoading = true;
        this.contratosGestaoService.obterContratosGestao().subscribe(data => {
            this.listaContratos = data;
            this.searchLoading = false;
        }, error => {
            console.log("erro: " + error);
            this.searchLoading = false;
        });

       /* this.contratosGestaoService.obterAnalise(this.idSecaoPagina).subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });*/

        this.loading = true;
        this.contratosGestaoService.obterAnalisePag(1, this.idSecaoPagina).subscribe(data => {
            this.listaDados = data.analises;
            this.loading = false;
            this.pagination.TotalItems = data.qtdPags;
            this.desabilitarImportacao = this.listaDados.length > 0;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    buscarContratos(term: string): Observable<any[]> {
        return this.contratosGestaoService.obterContratosGestaoPorNumero(term);
    }

    onSelect(item: any) {
        this.selectedItem = item;
    }

    onInputChangedEvent(val: string) {
        this.inputChanged = val;
    }

    fileChange(event) {
        this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
            if (callback) {
                this.loading = true;
                this.fileService.cargaAnalises(event, this.idSecaoPagina).subscribe(data => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.dadosImportados = data;      

                    for (let j = 0; j < this.dadosImportados.length; j++) {
                        
                        //if ( this.listaDados.findIndex(
                          //      i => { 
                            //        return i.cpf.replace(/[^\w\s]/gi, '') === this.dadosImportados[j].cpf.replace(/[^\w\s]/gi, '') 
                              //      && i.contratoGestao.nmContrato === this.dadosImportados[j].contratoGestao.nmContrato;
                                //} 
                            //) == -1) 
                        //{
                            this.listaDados.push(this.dadosImportados[j]);
                        //} else {
                          //  this.alertService.mostraAlerta("Importação interrompida.","O CPF " + this.dadosImportados[j].cpf + " já foi adicionado ao contrato " + this.dadosImportados[j].contratoGestao.nmContrato);
                           // this.loading = false;
                            //return;         
                        //}
                    }
                   
                    this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
                    this.loading = false;    

                }, error => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.alertService.mostraAlerta("Houve um erro ao carregar o arquivo.", error.mensagem);
                    this.loading = false;
                });
            } else {
                this.inputFileCMVar.nativeElement.value = "";
            }
        });
    }

    downloadDoModelo() {
        this.fileService.downloadModeloCargaContratoGestao(this.idSecaoPagina);
    }

    adicionarRelatorio() {

        if (!this.cpfInvalido) {

            if (this.relatorioParaAdicionar.nmContrato != '' &&
                this.relatorioParaAdicionar.nomePessoa != '' &&
                this.relatorioParaAdicionar.funcaoDesenvolvida != '' &&
                this.relatorioParaAdicionar.dataAdmissao != '' &&
                this.relatorioParaAdicionar.cpf != ''
            ) {

                let relatorioNovo = {
                    "id": 0,
                    "idModuloAnalise": 0,
                    "contratoGestao": {
                        "id": 0,
                        "nmContrato": this.relatorioParaAdicionar.nmContrato,
                        "credor": "",
                        "cpf": "",
                        "cnpj": "",
                        "objeto": "",
                        "dataAssinatura": "",
                        "inicioVigencia": "",
                        "fimVigencia": "",
                        "dataPublicacao": "",
                        "valorInicial": 0,
                        "responsavel": "",
                        "novaDataVigencia": "",
                        "valorAtual": 0,
                        "aditivos": [],
                        "flCertificado": false,
                        "situacao": "",
                        "dtPrazoPublicacao": "",
                        "diasForaDoPrazo": "",
                        "codSituacao": 0,
                        "arquivos": []
                    },
                    "dsMetas": "",
                    "dsAtividade": "",
                    "quantidadePrevista": 0,
                    "valorUnitarioPrevisto": 0,
                    "totalPrevisto": 0,
                    "quantidadeRealizada": 0,
                    "valorUnitarioRealizado": 0,
                    "totalRealizado": 0,
                    "recursosRecebidos": 0,
                    "restituicoes": 0,
                    "transferencias": 0,
                    "rendAcumulados": 0,
                    "outrasReceitas": 0,
                    "despesasPeriodo": 0,
                    "despesasFinanceiras": 0,
                    "tipoDespesa": "",
                    "naturezaDespesa": "",
                    "numeroCheque": "",
                    "dataEmissao": "",
                    "dataPagamento": "",
                    "valorDocumento": "",
                    "valorPago": "",
                    "numeroEditalCotacao": "",
                    "dataEditalCotacao": "",
                    "exercicio": "",
                    "valorRetirado": 0,
                    "dataRetornoRecurso": "",
                    "valorRetorno": 0,
                    "valorCorrecao": 0,
                    "justificativa": "",
                    "destinacaoValor": "",
                    "prazoReposicao": "",
                    "orgSocial": this.relatorioParaAdicionar.orgSocial,
                    "nomePessoa": this.relatorioParaAdicionar.nomePessoa,
                    "dataAdmissao": this.relatorioParaAdicionar.dataAdmissao,
                    "dataDesligamento": this.relatorioParaAdicionar.dataDesligamento,
                    "funcaoDesenvolvida": this.relatorioParaAdicionar.funcaoDesenvolvida,
                    "cpf": this.relatorioParaAdicionar.cpf,
                    "valorJaneiro": this.relatorioParaAdicionar.valorJaneiro,
                    "valorFevereiro": this.relatorioParaAdicionar.valorFevereiro,
                    "valorMarco": this.relatorioParaAdicionar.valorMarco,
                    "valorAbril": this.relatorioParaAdicionar.valorAbril,
                    "valorMaio": this.relatorioParaAdicionar.valorMaio,
                    "valorJunho": this.relatorioParaAdicionar.valorJunho,
                    "valorJulho": this.relatorioParaAdicionar.valorJulho,
                    "valorAgosto": this.relatorioParaAdicionar.valorAgosto,
                    "valorSetembro": this.relatorioParaAdicionar.valorSetembro,
                    "valorOutubro": this.relatorioParaAdicionar.valorOutubro,
                    "valorNovembro": this.relatorioParaAdicionar.valorNovembro,
                    "valorDezembro": this.relatorioParaAdicionar.valorDezembro,
                    "totalExercicio": 0
                };

                // let tipoVinculoTemp = this.listaContratosAux.filter((contrato) => this.relatorioParaAdicionar.nmContrato == contrato.nmContrato)[0];

                this.contratoService.obterPorNumeroContrato(this.relatorioParaAdicionar.nmContrato).subscribe(data => {
                    if (data != null) {
                        relatorioNovo.contratoGestao.id = data.id;
                        relatorioNovo.contratoGestao.nmContrato = data.nmContrato;
                        relatorioNovo.contratoGestao.credor = data.credor;
                        relatorioNovo.contratoGestao.cpf = data.cpf;
                        relatorioNovo.contratoGestao.cnpj = data.cnpj;
                        relatorioNovo.contratoGestao.objeto = data.objeto;
                        relatorioNovo.contratoGestao.dataAssinatura = data.dataAssinatura;
                        relatorioNovo.contratoGestao.inicioVigencia = data.inicioVigencia;
                        relatorioNovo.contratoGestao.fimVigencia = data.fimVigencia;
                        relatorioNovo.contratoGestao.dataPublicacao = data.dataPublicacao;
                        relatorioNovo.contratoGestao.valorInicial = data.valorInicial;
                        relatorioNovo.contratoGestao.responsavel = data.responsavel;
                        relatorioNovo.contratoGestao.novaDataVigencia = data.novaDataVigencia;
                        relatorioNovo.contratoGestao.valorAtual = data.valorAtual;
                        relatorioNovo.contratoGestao.aditivos = data.aditivos;
                        relatorioNovo.contratoGestao.flCertificado = data.flCertificado;
                        relatorioNovo.contratoGestao.situacao = data.situacao;
                        relatorioNovo.contratoGestao.dtPrazoPublicacao = data.dtPrazoPublicacao;
                        relatorioNovo.contratoGestao.diasForaDoPrazo = data.diasForaDoPrazo;
                        relatorioNovo.contratoGestao.codSituacao = data.codSituacao;
                        relatorioNovo.contratoGestao.arquivos = data.arquivos;

                    }

                    if (this.objetoEdit) {
                        let index = this.listaDados.indexOf(this.objetoEdit);
                        this.listaDados.splice(index, 1);

                        this.listEdit.push(this.objetoEdit);
                    }

                    this.listaDados.push(relatorioNovo);

                    this.objetoEdit = null;

                    this.relatorioParaAdicionar.nmContrato =
                        this.relatorioParaAdicionar.orgSocial =
                        this.relatorioParaAdicionar.nomePessoa =
                        this.relatorioParaAdicionar.funcaoDesenvolvida =
                        this.relatorioParaAdicionar.cpf =
                        this.relatorioParaAdicionar.valorJaneiro =
                        this.relatorioParaAdicionar.valorFevereiro =
                        this.relatorioParaAdicionar.valorMarco =
                        this.relatorioParaAdicionar.valorAbril =
                        this.relatorioParaAdicionar.valorMaio =
                        this.relatorioParaAdicionar.valorJunho =
                        this.relatorioParaAdicionar.valorJulho =
                        this.relatorioParaAdicionar.valorAgosto =
                        this.relatorioParaAdicionar.valorSetembro =
                        this.relatorioParaAdicionar.valorOutubro =
                        this.relatorioParaAdicionar.valorNovembro =
                        this.relatorioParaAdicionar.valorDezembro = '';

                    this.comboContratos = null;

                    this.relatorioParaAdicionar.dataAdmissao =
                        this.relatorioParaAdicionar.dataDesligamento = null;

                    let copy = {
                        dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
                        monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
                        dateFormat: 'dd/mm/yyyy',
                        todayBtnTxt: 'Hoje',
                        firstDayOfWeek: 'su',
                        disableWeekends: false,
                        editableDateField: true,
                        openSelectorOnInputClick: true,
                        showClearDateBtn: false,
                        openSelectorTopOfInput: true,
                        showSelectorArrow: false,
                        componentDisabled: true
                    };

                    this.myDatePickerDesligamentoOptions = copy;
                }, error => {
                    console.log("erro: " + error);
                    this.searchLoading = false;
                });

            } else {
                this.alertService.mostraAlerta("", "Necessário preencher todos os campos do formulário.");
            }
        } else {
            this.alertService.mostraAlerta("", "O CPF informado é inválido.");
        }

    }

    getCopyOfAdmissaoOptions(): IMyDpOptions {
        return JSON.parse(JSON.stringify(this.myDatePickerAdmissaoOptions));
    }

    getCopyOfDesligamentoOptions(): IMyDpOptions {
        return JSON.parse(JSON.stringify(this.myDatePickerDesligamentoOptions));
    }

    onDataAdmissaoChanged(event: IMyDateModel) {
        if (event.jsdate !== null) {
            this.relatorioParaAdicionar.dataAdmissao = new Date(event.jsdate).toLocaleDateString('pt-br');

            //let date = new Date();
            let copy = this.getCopyOfDesligamentoOptions();

            copy.componentDisabled = false;
            copy.disableUntil = { year: event.date.year, month: event.date.month, day: event.date.day - 1 };

            this.myDatePickerDesligamentoOptions = copy;
        }
    }

    onDataDesligamentoChanged(event: IMyDateModel) {
        if (event.jsdate !== null) {
            this.relatorioParaAdicionar.dataDesligamento = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }

    removerRelatorio(item, edit) {

        if (!edit) {
            this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
                if (callback) {

                    let index = this.listaDados.indexOf(item);
                    this.listaDados.splice(index, 1);

                    if (item.id != 0) {
                        this.deletarRelatorio(item.id, edit);
                    }
                }
            });
        } else {
            // let index = this.listaDados.indexOf(item);
            // this.listaDados.splice(index, 1);

            if (item.id != 0) {
                this.deletarRelatorio(item.id, edit);
            }
        }
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaContratosGestao() {
        this.menuService.redirecionarPagina(this.contratosGestaoService.obterIdPaginaContratosGestao());
    }

    salvar() {

        this.listEdit.forEach(item => {
            this.removerRelatorio(item, true);
        });

        this.listEdit = [];

        for (let j = 0; j < this.listaDados.length; j++) {
            this.listaDados[j].cpf = this.listaDados[j].cpf.replace(/[^\w\s]/gi, '');
        }

        this.contratosGestaoService.salvarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.carregarDados();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        })
    }

    deletarRelatorio(idContratoGestao, edit) {
        this.contratosGestaoService.deletarAnalise(idContratoGestao, this.idSecaoPagina).subscribe(data => {
            if (!edit) {
                this.alertService.mostraAlerta("", "Removido com sucesso.");
            }
        }, error => {
            this.alertService.mostraAlerta("Erro ao excluir", "O registro pode estar vinculado a outra análise no sistema.");
            this.carregarDados();
        })
    }

    finalizar() {

        this.listEdit.forEach(item => {
            this.removerRelatorio(item, true);
        });

        this.listEdit = [];

        if (this.listaDados) {
            this.contratosGestaoService.finalizarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                this.voltarParaContratosGestao();
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
            });
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    onCPFAlterado() {
        if (this.validarCPF(this.relatorioParaAdicionar.cpf)) {
            this.cpfInvalido = false;
        }
        else {
            this.cpfPreenchido = false;
        }
    }

    cpf_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }

    validarCPF(cpf) {
        let ehValido = true;

        cpf = cpf.replace(/[^\w\s]/gi, '');

        if (cpf == undefined) {
            this.cpfInvalido = false;
            return false;
        }

        if (cpf.length != 11) {
            this.cpfInvalido = false;
            return false;
        }

        // Elimina CPFs invalidos conhecidos
        if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
            cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
            cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
            this.cpfInvalido = true;
            return false;
        }

        // Valida 1o digito
        let add = 0;
        for (let i = 0; i < 9; i++)
            add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(9))) {
            this.cpfInvalido = true;
            return false;
        }

        // Valida 2o digito
        add = 0;
        for (let i = 0; i < 10; i++) {
            add += parseInt(cpf.charAt(i)) * (11 - i);
        }
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(10))) {
            this.cpfInvalido = true;
            return false;
        }

        return ehValido;
    }

    onContratoChange(contrato) {

        if (contrato != null && contrato != undefined) {
            this.relatorioParaAdicionar.orgSocial = contrato.dsCredor;
            this.relatorioParaAdicionar.nmContrato = contrato.nmContrato;
        } else {
            this.relatorioParaAdicionar.orgSocial = '';
            this.relatorioParaAdicionar.nmContrato = '';
        }
    }

    onValorChange(mes) {
        console.log("Valor " + this.relatorioParaAdicionar.valorJaneiro);
        if (mes == 'jan') {
           this.relatorioParaAdicionar.valorFevereiro = this.relatorioParaAdicionar.valorJaneiro; 
            this.relatorioParaAdicionar.valorMarco = this.relatorioParaAdicionar.valorJaneiro; 
            this.relatorioParaAdicionar.valorAbril = this.relatorioParaAdicionar.valorJaneiro; 
             this.relatorioParaAdicionar.valorMaio = this.relatorioParaAdicionar.valorJaneiro; 
            this.relatorioParaAdicionar.valorJunho = this.relatorioParaAdicionar.valorJaneiro; 
            this.relatorioParaAdicionar.valorJulho = this.relatorioParaAdicionar.valorJaneiro; 
            this.relatorioParaAdicionar.valorAgosto = this.relatorioParaAdicionar.valorJaneiro; 
           this.relatorioParaAdicionar.valorSetembro = this.relatorioParaAdicionar.valorJaneiro; 
          this.relatorioParaAdicionar.valorOutubro = this.relatorioParaAdicionar.valorJaneiro; 
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorJaneiro; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorJaneiro; }
         else if (mes == 'fev') {
            this.relatorioParaAdicionar.valorMarco = this.relatorioParaAdicionar.valorFevereiro; 
          this.relatorioParaAdicionar.valorAbril = this.relatorioParaAdicionar.valorFevereiro; 
             this.relatorioParaAdicionar.valorMaio = this.relatorioParaAdicionar.valorFevereiro; 
            this.relatorioParaAdicionar.valorJunho = this.relatorioParaAdicionar.valorFevereiro; 
            this.relatorioParaAdicionar.valorJulho = this.relatorioParaAdicionar.valorFevereiro; 
            this.relatorioParaAdicionar.valorAgosto = this.relatorioParaAdicionar.valorFevereiro; 
           this.relatorioParaAdicionar.valorSetembro = this.relatorioParaAdicionar.valorFevereiro; 
          this.relatorioParaAdicionar.valorOutubro = this.relatorioParaAdicionar.valorFevereiro; 
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorFevereiro; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorFevereiro; }
         else if (mes == 'mar') {
          this.relatorioParaAdicionar.valorAbril = this.relatorioParaAdicionar.valorMarco; 
             this.relatorioParaAdicionar.valorMaio = this.relatorioParaAdicionar.valorMarco; 
            this.relatorioParaAdicionar.valorJunho = this.relatorioParaAdicionar.valorMarco; 
            this.relatorioParaAdicionar.valorJulho = this.relatorioParaAdicionar.valorMarco; 
            this.relatorioParaAdicionar.valorAgosto = this.relatorioParaAdicionar.valorMarco; 
           this.relatorioParaAdicionar.valorSetembro = this.relatorioParaAdicionar.valorMarco; 
          this.relatorioParaAdicionar.valorOutubro = this.relatorioParaAdicionar.valorMarco; 
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorMarco; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorMarco; }
         else if (mes == 'abr') {
             this.relatorioParaAdicionar.valorMaio = this.relatorioParaAdicionar.valorAbril; 
            this.relatorioParaAdicionar.valorJunho = this.relatorioParaAdicionar.valorAbril; 
            this.relatorioParaAdicionar.valorJulho = this.relatorioParaAdicionar.valorAbril; 
            this.relatorioParaAdicionar.valorAgosto = this.relatorioParaAdicionar.valorAbril; 
           this.relatorioParaAdicionar.valorSetembro = this.relatorioParaAdicionar.valorAbril; 
          this.relatorioParaAdicionar.valorOutubro = this.relatorioParaAdicionar.valorAbril; 
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorAbril; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorAbril; }
         else if (mes == 'mai') {
            this.relatorioParaAdicionar.valorJunho = this.relatorioParaAdicionar.valorMaio; 
            this.relatorioParaAdicionar.valorJulho = this.relatorioParaAdicionar.valorMaio; 
            this.relatorioParaAdicionar.valorAgosto = this.relatorioParaAdicionar.valorMaio; 
           this.relatorioParaAdicionar.valorSetembro = this.relatorioParaAdicionar.valorMaio; 
          this.relatorioParaAdicionar.valorOutubro = this.relatorioParaAdicionar.valorMaio; 
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorMaio; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorMaio; }
         else if (mes == 'jun') {
            this.relatorioParaAdicionar.valorJulho = this.relatorioParaAdicionar.valorJunho; 
            this.relatorioParaAdicionar.valorAgosto = this.relatorioParaAdicionar.valorJunho; 
           this.relatorioParaAdicionar.valorSetembro = this.relatorioParaAdicionar.valorJunho; 
          this.relatorioParaAdicionar.valorOutubro = this.relatorioParaAdicionar.valorJunho; 
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorJunho; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorJunho; }
         else if (mes == 'jul') {
            this.relatorioParaAdicionar.valorAgosto = this.relatorioParaAdicionar.valorJulho; 
           this.relatorioParaAdicionar.valorSetembro = this.relatorioParaAdicionar.valorJulho; 
          this.relatorioParaAdicionar.valorOutubro = this.relatorioParaAdicionar.valorJulho; 
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorJulho; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorJulho; }
         else if (mes == 'ago') {
           this.relatorioParaAdicionar.valorSetembro = this.relatorioParaAdicionar.valorAgosto; 
          this.relatorioParaAdicionar.valorOutubro = this.relatorioParaAdicionar.valorAgosto; 
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorAgosto; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorAgosto; }
         else if (mes == 'set') {
          this.relatorioParaAdicionar.valorOutubro = this.relatorioParaAdicionar.valorSetembro; 
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorSetembro; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorSetembro; }
         else if (mes == 'out') {
           this.relatorioParaAdicionar.valorNovembro = this.relatorioParaAdicionar.valorOutubro; 
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorOutubro; }
         else if (mes == 'nov') {
             this.relatorioParaAdicionar.valorDezembro = this.relatorioParaAdicionar.valorNovembro; }
    }  
    

    editar(item) {
        this.comboContratos = item.contratoGestao.nmContrato;
        this.relatorioParaAdicionar.nmContrato = item.contratoGestao.nmContrato;
        this.relatorioParaAdicionar.orgSocial = item.orgSocial;
        this.relatorioParaAdicionar.nomePessoa = item.nomePessoa;
        this.relatorioParaAdicionar.funcaoDesenvolvida = item.funcaoDesenvolvida;
        this.relatorioParaAdicionar.cpf = item.cpf;
        this.relatorioParaAdicionar.valorJaneiro = item.valorJaneiro;
        this.relatorioParaAdicionar.valorFevereiro = item.valorFevereiro;
        this.relatorioParaAdicionar.valorMarco = item.valorMarco;
        this.relatorioParaAdicionar.valorAbril = item.valorAbril;
        this.relatorioParaAdicionar.valorMaio = item.valorMaio;
        this.relatorioParaAdicionar.valorJunho = item.valorJunho;
        this.relatorioParaAdicionar.valorJulho = item.valorJulho;
        this.relatorioParaAdicionar.valorAgosto = item.valorAgosto;
        this.relatorioParaAdicionar.valorSetembro = item.valorSetembro;
        this.relatorioParaAdicionar.valorOutubro = item.valorOutubro;
        this.relatorioParaAdicionar.valorNovembro = item.valorNovembro;
        this.relatorioParaAdicionar.valorDezembro = item.valorDezembro;

        this.relatorioParaAdicionar.dataAdmissao = item.dataAdmissao;
        this.relatorioParaAdicionar.dataDesligamento = item.dataDesligamento;

        let copy = this.getCopyOfDesligamentoOptions();

        copy.componentDisabled = false;

        copy.disableUntil = { year: item.dataAdmissao.split("/", 3)[2], month: item.dataAdmissao.split("/", 3)[1].replace(/^0+/, ''), day: item.dataAdmissao.split("/", 3)[0].replace(/^0+/, '') - 1 };

        this.myDatePickerDesligamentoOptions = copy;

        this.objetoEdit = item;
    }

    printData() {

        var doc = new jsPDF("l");
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // HEADER
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle('normal');

            doc.text("Relação do Pessoal Vinculado ao Contrato de Gestão", data.settings.margin.left + 15, 22);

            // FOOTER
            var str = "Page " + data.pageCount;
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp;
            }
            doc.setFontSize(10);
            doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        };

        var columns = [
            { title: "Nº Contrato SAC/SCC", dataKey: "contrato" },
            { title: "Organização Social", dataKey: "org" },
            { title: "Nome", dataKey: "nome" },
            { title: "CPF", dataKey: "cpf" },
            { title: "Admissão", dataKey: "adm" },
            { title: "Desligamento", dataKey: "desl" },
            { title: "Jan", dataKey: "jan" },
            { title: "Fev", dataKey: "fev" },
            { title: "Mar", dataKey: "mar" },
            { title: "Abr", dataKey: "abr" },
            { title: "Mai", dataKey: "mai" },
            { title: "Jun", dataKey: "jun" },
            { title: "Jul", dataKey: "jul" },
            { title: "Ago", dataKey: "ago" },
            { title: "Set", dataKey: "set" },
            { title: "Out", dataKey: "out" },
            { title: "Nov", dataKey: "nov" },
            { title: "Dez", dataKey: "dez" }
        ];

        let rows = [];

        this.listaDados.forEach(contrato => {

            var item = {
                "contrato": contrato.contratoGestao.nmContrato,
                "org": contrato.orgSocial,
                "nome": contrato.nomePessoa,
                "cpf": contrato.cpf != '' ? this.cpf_mask(contrato.contratoGestao.cpf) : "",
                "adm": contrato.dataAdmissao,
                "desl": contrato.dataDesligamento,
                "jan": this.formatarValorNumerico(contrato.valorJaneiro),
                "fev": this.formatarValorNumerico(contrato.valorFevereiro),
                "mar": this.formatarValorNumerico(contrato.valorMarco),
                "abr": this.formatarValorNumerico(contrato.valorAbril),
                "mai": this.formatarValorNumerico(contrato.valorMaio),
                "jun": this.formatarValorNumerico(contrato.valorJunho),
                "jul": this.formatarValorNumerico(contrato.valorJulho),
                "ago": this.formatarValorNumerico(contrato.valorAgosto),
                "set": this.formatarValorNumerico(contrato.valorSetembro),
                "out": this.formatarValorNumerico(contrato.valorOutubro),
                "nov": this.formatarValorNumerico(contrato.valorNovembro),
                "dez": this.formatarValorNumerico(contrato.valorDezembro)
            };

            rows.push(item);
        });

        doc.autoTable(columns, rows, {
            theme: 'grid',
            addPageContent: pageContent,
            margin: { top: 30 },
            styles: {
                overflow: 'linebreak',
                columnWidth: 'auto',
                fontSize: 6
            },
            columnStyles: {
                desc: { columnWidth: 'auto' }
            }
        });

        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        doc.save('relatorio_pessoal_vinculado.pdf');
    }

    modalEvidencias(item: any) {

        let titulo = "Evidências";

        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: item.contratoGestao.nmContrato,
                idModuloPCA: this.codigoModulo,
                tipoAnalise: 0,
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Processo: " + item.contratoGestao.nmContrato,
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });

        modal.present();

    }

    loadPage(Page: number) {
        this.pagination.CurrentPage = Page;
        this.loading = true;
        this.contratosGestaoService.obterAnalisePag(Page, this.idSecaoPagina).subscribe(data => {
          this.listaDados =  data.analises;
          this.loading = false;
          this.pagination.TotalItems = data.qtdPags;
        }, error => {
          console.log("erro: " + error.mensagem);
          this.loading = false;
        });
      }

      deletarTodos(){
        this.alertService.mostraModalConfirmacao("Excluir os registros", "Deseja excluir " + this.pagination.TotalItems + " registro(s)?", callback => {
            if (callback) {
                this.loading = true;
                this.contratosGestaoService.deletarTodos(this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("Exclusão concluída","Todos os registros foram excluídos.");
                    this.carregarDados();
                }, error => {
                    console.log("erro: " + error);
                    this.alertService.mostraAlerta("Erro ao excluir", "Algum registro pode estar vinculado a outra análise no sistema.");
                    this.carregarDados();                   
                });
            }
        });        
      }

      importarDoAnoAnterior() {

        this.alertService.mostraModalConfirmacao("Importar do Ano Anterior", 
            "Recomenda-se realizar a importação dos dados por meio do template de carga em massa."+
            "<br />Deseja continuar a importação dos registros do ano anterior mesmo assim?", 
            callback => {            
                if (callback) {
                    this.loading = true;
                    this.desabilitarImportacao = true;
                    this.contratosGestaoService.carregarAnoAnterior(this.idSecaoPagina).subscribe(data => {
                        this.alertService.mostraAlerta("", data.mensagem);
                        this.carregarDados();
                    }, error => {
                        console.log("erro: " + error.mensagem);
                        this.alertService.mostraAlerta("Erro ao importar", error.mensagem);
                        this.carregarDados();
                    });
                }
            }
        );

    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/pessoal-vinculado/pessoal-vinculado.ts